/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function SuccessIcon({ size = 'small', className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      className={className}
      viewBox="0 0 20 20"
    >
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M10 18.5a8.5 8.5 0 10-.001-17.001A8.5 8.5 0 0010 18.5zm0 1C4.753 19.5.5 15.247.5 10S4.753.5 10 .5s9.5 4.253 9.5 9.5-4.253 9.5-9.5 9.5zm3.464-12.021a.5.5 0 11.704.71l-5.169 5.117-2.493-2.763a.5.5 0 11.743-.67l1.791 1.985 4.424-4.38z"
      ></path>
    </svg>
  );
}
